import { useNavigate } from "react-router-dom";

import { Button } from "@naluri-hidup/reusable-web-components";
import { Icon, Background } from "src/components";
import { useAuthStore } from "src/store";

const reachOutText =
  "Please reach out to CIA squad @Slack Channel (#squad-cia-ops-ext) for authorisation.";

const callbackUrl = `${
  process.env.REACT_APP_ADMIN_API_HOST
}/auth/link?callbackUrl=${encodeURIComponent(
  window.location.origin + "/callback"
)}`;

const Login = ({
  redirecting,
  error,
  noPermission,
  pageNotFound,
}: {
  redirecting?: string;
  error?: string;
  noPermission?: boolean;
  pageNotFound?: boolean;
}) => {
  const navigate = useNavigate();
  const { reset, profile } = useAuthStore();
  const handleLogin = (event: any) => {
    // Hide button, prevent user on clicking the button in quick succession
    if (event && event.currentTarget) {
      event.currentTarget.style.display = "none";
      const progressText =
        event.currentTarget.parentNode.querySelector(".login-progress");
      if (progressText) {
        progressText.innerHTML = "Redirecting...";
      }
    }
    window.location.href = callbackUrl;
  };

  const checkStatus = () => {
    return (
      <>
        <div className="mb-3 login-progress">
          {error ? error : redirecting ? redirecting : ""}
        </div>
        {!redirecting ? (
          <>
            <button
              className="group w-full flex items-center justify-center space-x-3 whitespace-nowrap leading-normal transition-all border-2 bg-black border-black fill-white text-white rounded-full px-11 py-3 hover:bg-white hover:fill-black hover:text-black"
              onClick={(event) => handleLogin(event)}
            >
              {error ? (
                "Try again"
              ) : (
                <>
                  <Icon name="logo-google" />
                  <span>Login with Google</span>
                </>
              )}
            </button>
          </>
        ) : null}
      </>
    );
  };

  return (
    <Background noPermission={noPermission || pageNotFound}>
      <div className="m-12 flex flex-col justify-between">
        <Icon name="logo-admin" />
        {noPermission || pageNotFound ? (
          <div className="flex flex-col gap-y-3">
            <div className="font-extrabold text-3xl mb-2">
              Sorry, either your account is not authorised or the page you are
              accessing doesn't exist
            </div>
            <div className="inline">
              <Button
                pill
                size={"md"}
                variant={"solid"}
                color={"black"}
                label={"Back to Home"}
                onClick={async () => {
                  if (!profile.id) {
                    reset();
                  }
                  navigate("/");
                }}
                className={"fill-white hover:fill-admin-black"}
              />
            </div>
            <ol className="list-decimal list-inside">
              <li>{reachOutText}</li>
              <li>
                Click{" "}
                <a
                  className="underline text-blue-600 hover:text-blue-800 visited:text-purple-600"
                  href={callbackUrl}
                >
                  here
                </a>{" "}
                to relogin after we grant you the access
              </li>
            </ol>
          </div>
        ) : (
          <div
            className="rounded-2xl bg-white p-14 my-10 w-screen h-screen"
            style={{ maxWidth: "33vw", minWidth: "400px", maxHeight: "70vh" }}
          >
            <div className="flex flex-col">
              <div className="mb-12">
                <div className="font-extrabold text-3xl mb-2">Admin Login</div>
                <span className="text-slate-400">
                  Hi there! Login with your Naluri account
                </span>
              </div>
              <div>{checkStatus()}</div>
              <hr className="my-9 h-px border-0 bg-gray-400" />
              <div className="text-base">
                <span className="text-slate-400">Do not have access yet? </span>
                <span>{reachOutText}</span>
              </div>
            </div>
          </div>
        )}
        <div></div>
      </div>
    </Background>
  );
};

export default Login;
